import { API } from 'src/definitions';
import Schema from 'validate';

export default new Schema<API.Engagements.AddEngagementInBulk.Request>(
  {
    title: {
      required: true,
      type: 'string',
      message: {
        required: 'A title is required'
      }
    },
    body: {
      required: true,
      type: 'string',
      message: {
        required: 'A body is required'
      }
    },
    consumerIds: {
      required: true,
      type: 'array',
      message: {
        required: 'A consumer id is required'
      }
    }
  },
  { strip: false }
);
